import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CTA_COLOR_BY_NAME } from 'constants/colors';
import { CallToAction, ACTIONS } from 'components/CallToAction';
import { CMS_CTA_TYPES } from './constants';
export var CmsCta =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CmsCta, _PureComponent);

  function CmsCta() {
    _classCallCheck(this, CmsCta);

    return _possibleConstructorReturn(this, _getPrototypeOf(CmsCta).apply(this, arguments));
  }

  _createClass(CmsCta, [{
    key: "ctaColor",
    value: function ctaColor(color, isPrimary) {
      return CTA_COLOR_BY_NAME[color] || isPrimary && CTA_COLOR_BY_NAME.primary_solid || CTA_COLOR_BY_NAME.default;
    }
  }, {
    key: "parseProps",
    value: function parseProps(_ref) {
      var children = _ref.children,
          copy = _ref.copy,
          extraProps = _objectWithoutProperties(_ref, ["children", "copy"]);

      return _objectSpread({}, extraProps, {
        children: children || copy
      });
    }
  }, {
    key: "renderCallToAction",
    value: function renderCallToAction(action) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
      return React.createElement(CallToAction, _extends({}, this.parseProps(props), {
        action: action
      }));
    }
    /**
     * The URL CTA has some legacy color handling to normalize
     * the colors to our standard CTA colors.
     */

  }, {
    key: "renderUrlCallToAction",
    value: function renderUrlCallToAction() {
      var _this$props = this.props,
          color = _this$props.color,
          extraClass = _this$props.extraClass,
          isPrimary = _this$props.isPrimary,
          url = _this$props.url,
          extraProps = _objectWithoutProperties(_this$props, ["color", "extraClass", "isPrimary", "url"]);

      var ctaClassName = classNames(extraClass, this.ctaColor(color, isPrimary));
      return this.renderCallToAction(ACTIONS.LINK, _objectSpread({}, extraProps, {
        to: url,
        extraClass: ctaClassName
      }));
    }
    /**
     * The YouTube CTA has some legacy color handling to normalize
     * the colors to our standard CTA colors.
     */

  }, {
    key: "renderYoutubeCallToAction",
    value: function renderYoutubeCallToAction() {
      var _classNames;

      var _this$props2 = this.props,
          color = _this$props2.color,
          extraClass = _this$props2.extraClass,
          isPrimary = _this$props2.isPrimary,
          theme = _this$props2.theme,
          videoId = _this$props2.videoId,
          extraProps = _objectWithoutProperties(_this$props2, ["color", "extraClass", "isPrimary", "theme", "videoId"]);

      var extraClassWithColors = classNames(extraClass, this.ctaColor(color, isPrimary), (_classNames = {}, _defineProperty(_classNames, CTA_COLOR_BY_NAME.marketing_white, !color && theme === 'light'), _defineProperty(_classNames, CTA_COLOR_BY_NAME.primary, !color && theme === 'dark'), _classNames));
      return this.renderCallToAction(ACTIONS.SHOW_MODAL, _objectSpread({}, extraProps, {
        extraClass: extraClassWithColors,
        modalName: 'YouTubeVideoModal',
        modalProps: {
          videoId: videoId
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      switch (this.props.type) {
        case CMS_CTA_TYPES.OFFER_CHECKOUT:
          return this.renderCallToAction(ACTIONS.OFFER_CHECKOUT);

        case CMS_CTA_TYPES.RAF:
          return this.renderCallToAction(ACTIONS.SHOW_FRIENDBUY_WIDGET);

        case CMS_CTA_TYPES.YOUTUBE_VIDEO:
          return this.renderYoutubeCallToAction();

        case CMS_CTA_TYPES.URL:
          return this.renderUrlCallToAction();

        default:
          return null;
      }
    }
  }]);

  return CmsCta;
}(PureComponent);
CmsCta.propTypes = {
  color: PropTypes.string,
  copy: PropTypes.string,
  children: PropTypes.node,
  extraClass: PropTypes.string,
  isPrimary: PropTypes.bool,
  onClick: PropTypes.func,
  promotionAlias: PropTypes.string,
  theme: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
  videoId: PropTypes.string
};